<template>
    <div class="body-box" v-if="!loading">
        <div class="left-box">
            <leftArea :data="list.userTag"/>
        </div>
        <div class="center-box">
            <div id="centerTop">
                <dv-border-box-7>
                    <div class="tNumber">
                       客户地理、消费水平分布
                    </div>
                </dv-border-box-7>
            </div>
            <centerMap :data="list.consumeData" @change="onDateChange" />
        </div>
        <div class="right-box">
             <rightArea :data="list.userData" />
        </div>
    </div>
</template>

<script>
import centerMap from './user/map'
import leftArea from './user/left'
import rightArea from './user/right'

import { user } from '@/api/index'

export default {
    data() {
        return {
            list: {
                userTag: [],
                consumeData: [],
                userData: [],
            },
            loading: !0,
        }
    },
    components: {
        centerMap,
        leftArea,
        rightArea
    },
    mounted() {
        this.getData()
    },
    beforeDestroy() {

    },
    methods: {
        getData() {
            let fake = 1
            user({fake}, (res) => {
                this.list = res
                this.loading = !1
            })
        },
        onDateChange(type) {
            let fake = 1
            user({type,fake}, (res) => {
                this.list = res
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.body-box {
    grid-template-columns: 4fr 4fr 4fr!important;
}
#centerTop {
    .tNumber {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        font-weight: 500;
    }
}
</style>